import { DeclarationDr } from './declaration-dr.model';
import { DeclarationSV11 } from './declaration-sv11.model';
import { DeclarationSV12 } from './declaration-sv12.model';
import { DeclarationDpCave } from './declaration-dp-cave.model';
import { DeclarationDpNego } from './declaration-dp-nego.model';
import { DeclarationDpRecoltant } from './declaration-dp-recoltant.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class DeclarationRecolte {
    static jsonMap = {
        drs: { key: 'drs', converter: new (ArrayClassConverterFactory.build(DeclarationDr))(), optional: true, default: () => [] },
        sv11s: { key: 'sv11s', converter: new (ArrayClassConverterFactory.build(DeclarationSV11))(), optional: true, default: () => [] },
        sv12s: { key: 'sv12s', converter: new (ArrayClassConverterFactory.build(DeclarationSV12))(), optional: true, default: () => [] },
        dpcaves: { key: 'dpcaves', converter: new (ArrayClassConverterFactory.build(DeclarationDpCave))(), optional: true, default: () => [] },
        dpnegos: { key: 'dpnegos', converter: new (ArrayClassConverterFactory.build(DeclarationDpNego))(), optional: true, default: () => [] },
        dprecoltants: { key: 'dprecoltants', converter: new (ArrayClassConverterFactory.build(DeclarationDpRecoltant))(), optional: true, default: () => [] }
    };

    drs: DeclarationDr[];
    sv11s: DeclarationSV11[];
    sv12s: DeclarationSV12[];
    dpcaves: DeclarationDpCave[];
    dpnegos: DeclarationDpNego[];
    dprecoltants: DeclarationDpRecoltant[];
}
